import { Box, Tab, Tabs } from "@mui/material";

interface MapTabsProps {
  value: number;
  onChange: (value: number) => void;
}

export const MapTabs = ({ value, onChange }: MapTabsProps) => (
  <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
    <Tabs value={value} onChange={(_, v) => onChange(v)}>
      <Tab label="Map Data" />
      <Tab label="Map Settings" />
    </Tabs>
  </Box>
);
